<template>
    <div class="home">
        <q-card
            flat
            bordered
            v-for="(thread, index) in threads"
            :key="index"
            class="q-mb-sm"
            :class="{ 'bg-cyan-1': thread.id == selectedThread?.id }"
            v-touch-hold.mouse="() => selectThread(thread)"
        >
            <q-card-section horizontal>
                <q-card-section style="width: 100%">
                    <div class="text-h6 text-weight-bold text-cyan">{{ thread.subject }}</div>
                    <div class="text-subtitle1 text-weight-medium">{{ thread.message }}</div>
                    <div style="width: 100%; text-align: right">
                        {{ thread.sendDate }}
                    </div>
                </q-card-section>

                <q-separator vertical></q-separator>

                <q-card-section style="width: 100px">
                    <q-btn
                        color="indigo"
                        flat
                        icon="send"
                        @click="goToMessagesPage(thread.id)"
                    >
                        <q-badge
                            v-if="parseInt(thread.noOfUnread) > 0"
                            color="red"
                            floating
                            >{{ thread.noOfUnread }}</q-badge
                        >
                    </q-btn>
                </q-card-section>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { inject, onMounted, onUnmounted } from "@vue/runtime-core";
import axios from "axios";
import { BASE_PATH, emitter } from "@/main";

export default {
    name: "Home",
    components: {
        HelloWorld,
    },
    setup() {
        const threads = ref([]);
        const router = useRouter();
        const selectedThread = inject("selectedThread");

        const goToMessagesPage = (id) => {
            router.push({ name: "Messages", params: { id } });
        };

        const deleteThread = async () => {
            const { data } = await axios.post(
                `${BASE_PATH}/message-to-archive`,
                { parent: selectedThread.value.id }
            );
            location.reload();
        };

        onMounted(() => {
            emitter.on("delete-thread", deleteThread);
        });

        onMounted(async () => {
            const patient = JSON.parse(localStorage.getItem("USER"));
            const { data } = await axios.get(
                `${BASE_PATH}/get-pending-appointment`,
                { params: { userId: patient.Id } }
            );
            threads.value = data.pendingAppointment;
        });

        onUnmounted(() => {
            emitter.off("delete-thread", deleteThread);
        });

        return {
            threads,
            goToMessagesPage,
            selectedThread,
            selectThread: (thread) => {
                if (selectedThread.value != thread) {
                    selectedThread.value = thread;
                } else {
                    selectedThread.value = null;
                }
            },
        };
    },
};
</script>
